import { buildImageSrc } from "./buildImageSrc";
import { getCachedImage, ImageLoaderParams, planImage, setCachedImage } from "./imageLoader.shared";

/**
 * Loader do navegador: só monta a URL do arquivo que o build já gravou em
 * `public/`. É o que a entrada "browser" do pacote exporta como `myLoader`, e
 * o que o loader de servidor delega quando, mesmo assim, roda com `window`.
 */
export default function myLoader(params: ImageLoaderParams): string {
  const plan = planImage(params);
  if (plan.kind === 'base64') return plan.url;

  const cached = getCachedImage(plan.cacheKey);
  if (cached !== undefined) return cached;

  const finalImagePath = buildImageSrc(plan.publicPath);
  setCachedImage(plan.cacheKey, finalImagePath);
  return finalImagePath;
}
